import "@sphtech/affiliate-marketing-library/style.css";

import { configAffiliateLibrary, configSite } from "@pub/config";
import placeholders from "@pub/placeholders";
import { AffiliateMarketingWidget as AMWidget } from "@sphtech/affiliate-marketing-library";

import affilatesStyle from "./affiliates.module.css";
import {
  affiliateArrowLeft,
  affiliateArrowRight,
} from "./icons/affiliatesArrow";
import { defaultAMWidgetBreakpoints } from "./utils";

export function AffiliateMarketingWidget({ storyPath }: { storyPath: string }) {
  const breakpoints =
    configAffiliateLibrary.breakpoints || defaultAMWidgetBreakpoints;

  return (
    <div className={affilatesStyle.mainContainer}>
      <AMWidget
        // TODO: Use only lang
        // lang={configAffiliateLibrary.lang}
        customArrows={{
          left: configAffiliateLibrary.arrow?.left || affiliateArrowLeft,
          right: configAffiliateLibrary.arrow?.right || affiliateArrowRight,
        }}
        style={{
          heading: affilatesStyle.heading,
          headingContainer: affilatesStyle.headingContainer,
          carousel: {
            container: affilatesStyle.carouselContainer,
            arrow: {
              inactive: affilatesStyle.arrowInactive,
            },
          },
          card: {
            promo: affilatesStyle.promo,
            content: affilatesStyle.content,
            original: affilatesStyle.original,
            percentage: affilatesStyle.percentage,
            discount: affilatesStyle.discount,
            brand: affilatesStyle.brand,
            title: affilatesStyle.title,
            button: affilatesStyle.button,
            buttonContainer: affilatesStyle.buttonContainer || "",
            titleContainer: affilatesStyle.titleContainer,
            image: affilatesStyle.image,
          },
          disclaimer: affilatesStyle.disclaimer,
        }}
        storyUrl={`${configSite.address}${storyPath}`}
        options={{
          headerLabel: configAffiliateLibrary.headerLabel || "",
          ctaLabel: configAffiliateLibrary.ctaLabel || "",
          disclaimerLabel: configAffiliateLibrary.disclaimerLabel || "",
          breakpoints,
        }}
        errorSrc={placeholders.square.src || ""}
        eventCallback={{
          onClickItem: (data) => {
            if (typeof data == "undefined") return;
            const labelData = {
              name: data.name || "",
              price:
                data.deals.price.discountedPrice ||
                data.deals.price.original ||
                "",
              url: data.deals.url || "",
              position: data.position || 0,
            };
            const jsondata = JSON.stringify({
              type: "event",
              category: "shopping widget",
              action: "click",
              label: JSON.stringify(labelData),
            });
            window.SPHMGTM.cmd.push(`send=${jsondata}`);
          },
          onItemInView(data) {
            if (typeof data == "undefined") return;
            const labelData = {
              name: data.name || "",
              price:
                data.deals.price.discountedPrice ||
                data.deals.price.original ||
                "",
              url: data.deals.url || "",
              position: data.position || 0,
            };
            const jsondata = JSON.stringify({
              type: "event",
              category: "shopping widget",
              action: "impression",
              label: JSON.stringify(labelData),
            });
            window.SPHMGTM.cmd.push(`send=${jsondata}`);
          },
          onPrevClick() {
            const jsondata = JSON.stringify({
              type: "event",
              category: "shopping widget",
              action: "click",
              label: "left",
            });
            window.SPHMGTM.cmd.push(`send=${jsondata}`);
          },
          onNextClick() {
            const jsondata = JSON.stringify({
              type: "event",
              category: "shopping widget",
              action: "click",
              label: "right",
            });
            window.SPHMGTM.cmd.push(`send=${jsondata}`);
          },
        }}
      />
    </div>
  );
}
